import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
export default function UserDashboard() {
  const { t } = useTranslation();

  return (
    <>
      <div class="main-content-area">
        <div class="container">
          <h2 class="mb-3 text-center">
            {t('Explore Our Registered Services')}
          </h2>
          <div class="row justify-content-center">
            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-garages">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/garage.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Garages')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-spare-parts">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/spare-parts.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Spare Parts')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-car-dealers">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/car-dealer.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Car Dealers')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-cars-for-sale">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/car-for-sale.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Cars for Sale')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-rent-car">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/rent-a-car.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Rent a Car')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-taxi">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/taxi.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Taxi')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-car-wash">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/car-wash.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Car Wash')}</div>
                </Link>
              </div>
            </div>

            {/* <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-towing">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/car-towing.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">Car Towing</div>
                </Link>
              </div>
            </div> */}

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-car-insurance">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/car-insurance.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Car Insurance')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-driving-schools">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/driving-school.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Driving School')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-car-protection">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/car-protection.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Car Protection')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-air-conditioning">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/air-conditioning.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Air Conditioning')}</div>
                </Link>
              </div>
            </div>

            <div class="col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5">
              <div class="icons-dashboard hvr-float">
                <Link to="/user-quick-services">
                  <div class="line-a">
                    <img
                      src="assets/images/service-icons/quick-services.svg"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="line-b">{t('Quick Services')}</div>
                </Link>
              </div>
            </div>

            {/* <div class='col-6 col-sm-6 col-md-2 mb-5 mb-sm-5 mb-md-5'>
							<div class='icons-dashboard hvr-float'>
								<Link to='/user-cars-agents'>
									<div class='line-a'>
										<img
											src='assets/images/service-icons/cars-agents.svg'
											alt=''
											class='img-fluid'
										/>
									</div>
									<div class='line-b'>Cars Agents</div>
								</Link>
							</div>
						</div> */}
          </div>
        </div>
      </div>
    </>
  );
}
